function iniciarCardForm() {
    const assinatura_correntes_plano_id = document.querySelector("input[id$='assinatura_correntes_plano_id']");

    const plano_id = document.querySelector("input[id$='plano_id']");

    if (assinatura_correntes_plano_id.value != plano_id.value) {
        Swal.fire({
            title: 'Alteração de Plano',
            text: 'Você está prestes a alterar seu plano de assinatura. Ao confirmar a mudança, os dias restantes do seu plano atual serão cancelados e não poderão ser recuperados. Deseja continuar com a troca?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3483FA',
            cancelButtonColor: '#64748B',
            confirmButtonText: 'Sim, continuar',
            cancelButtonText: 'Não, manter plano atual',
            customClass: {
                title: 'text-lg font-semibold text-gray-700',
                content: 'text-sm text-gray-600',
                confirmButton: 'bg-blue-500 text-white font-medium rounded-md px-4 py-2 shadow-sm hover:bg-blue-600',
                cancelButton: 'bg-gray-300 text-gray-800 font-medium rounded-md px-4 py-2 shadow-sm hover:bg-gray-400',
            }
        }).then((result) => {
            if (result.isConfirmed) {
                iniciarCheckoutBricks();
            } else {
                document.getElementById('fecharModalAssinatura')?.click();
            }
        });
    } else {
        iniciarCheckoutBricks();
    }
}

window.iniciarCardForm = iniciarCardForm;

function iniciarCheckoutBricks() {
    console.log("🟡 Inicializando a construção do formulário de pagamento");

    const public_key_api_mercado_pago = document.querySelector("input[id$='public_key_api_mercado_pago']");

    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    let plano_preco = document.querySelector("input[id$='plano_preco']");
    plano_preco = parseFloat(plano_preco?.value) || 0;

    const plano_id = document.querySelector("input[id$='plano_id']");

    const rota_historico_pagamento = document.querySelector("input[id$='rota_historico_pagamento']");

    getPreferenceId(csrfToken, plano_id.value, plano_preco).then(preferenceId => {
        if (preferenceId) {
            // Verifica se já existe uma instância do MercadoPago e a destrói
            if (window.paymentBrickController) {
                window.paymentBrickController.unmount();
                window.paymentBrickController = null;
            }

            const mp = new MercadoPago(public_key_api_mercado_pago.value, {
                locale: 'pt-BR'
            });

            const bricksBuilder = mp.bricks();

            const renderPaymentBrick = async (bricksBuilder) => {
                const settings = {
                    initialization: {
                        /*
                          "amount" é a quantia total a pagar por todos os meios de pagamento com exceção da Conta Mercado Pago e Parcelas sem cartão de crédito, que têm seus valores de processamento determinados no backend através do "preferenceId"
                        */
                        amount: plano_preco,
                        preferenceId: preferenceId,
                        payer: {
                            firstName: "",
                            lastName: "",
                            email: "",
                        },
                    },
                    customization: {
                        visual: {
                            style: {
                                theme: "default",
                            },
                        },
                        paymentMethods: {
                            creditCard: "all",
                            debitCard: "all",
                            bankTransfer: "all",
                            atm: "all",
                            onboarding_credits: "all",
                            wallet_purchase: "all",
                            maxInstallments: 3
                        },
                    },
                    callbacks: {
                        onReady: () => {
                            /*
                             Callback chamado quando o Brick está pronto.
                             Aqui, você pode ocultar seu site, por exemplo.
                            */
                        },
                        onSubmit: ({ selectedPaymentMethod, formData }) => {

                            formData.plano_id = plano_id.value;

                            // callback chamado quando há click no botão de envio de dados
                            return new Promise((resolve, reject) => {
                                fetch("/process_payment", {
                                    method: "POST",
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-CSRF-TOKEN': csrfToken,
                                    },
                                    body: JSON.stringify(formData),
                                })
                                    .then((response) => response.json())
                                    .then((response) => {
                                        if (response.success) {
                                            const paymentId = response.payment_id;

                                            let external_resource_url = null;
                                            let creq = null;

                                            if ((response.three_ds_info !== null) && (response.three_ds_info !== undefined)) {
                                                const threeDsInfo = response.three_ds_info;

                                                external_resource_url = threeDsInfo.external_resource_url;
                                                creq = threeDsInfo.creq;
                                            }

                                            const threeDsInfo = response.three_ds_info;

                                            renderStatusScreenBrick(paymentId, bricksBuilder, external_resource_url, creq);

                                            document.getElementById('paymentBrick_container').style.display = 'none';
                                            document.getElementById('statusScreenBrick_container').style.display = 'block';

                                            resolve();
                                        } else {
                                            Swal.fire({
                                                title: 'Operação não Concluída!',
                                                html: 'Pedimos desculpas pelo ocorrido, mas identificamos que seu pagamento ainda não foi concluído em nosso sistema. <br><br>' +
                                                    'Este problema aparentemente é interno e não está relacionado ao seu cartão ou banco. <br><br> ' +
                                                    'Por favor, verifique com o seu banco se a transação foi realizada com sucesso antes de tentar um novo pagamento. <br><br>' +
                                                    'Caso o pagamento tenha sido efetuado e ainda não tenha sido reconhecido pelo sistema, entre em contato pelo e-mail <b>admin@gelsistemas.com.br</b>.',
                                                icon: 'error',
                                                confirmButtonText: '<span class="flex items-center"><svg class="w-5 h-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg> Entendido</span>',
                                                confirmButtonColor: "#3483FA",
                                                customClass: {
                                                    title: 'text-lg font-semibold text-gray-700',
                                                    content: 'text-sm text-gray-600',
                                                    confirmButton: 'bg-blue-500 text-white font-medium rounded-md px-4 py-2 shadow-sm hover:bg-blue-600',
                                                    cancelButton: 'bg-gray-300 text-gray-800 font-medium rounded-md px-4 py-2 shadow-sm hover:bg-gray-400',
                                                }
                                            }).then((result) => {
                                                document.getElementById('fecharModalAssinatura')?.click();
                                            });
                                        }
                                    })
                                    .catch((error) => {
                                        // manejar a resposta de erro ao tentar criar um pagamento
                                        reject();
                                    });
                            });
                        },
                        onError: (error) => {
                            // callback chamado para todos os casos de erro do Brick
                            console.error(error);
                        },
                    },
                };
                window.paymentBrickController = await bricksBuilder.create(
                    "payment",
                    "paymentBrick_container",
                    settings
                );
            };
            renderPaymentBrick(bricksBuilder)

            if (window.statusScreenBrickController) {
                window.statusScreenBrickController.unmount();
                window.statusScreenBrickController = null;
            }

            const renderStatusScreenBrick = async (paymentId, bricksBuilder, externalResourceUrl, cReq) => {
                const settings = {
                    initialization: {
                        paymentId: paymentId,
                        additionalInfo: {
                            externalResourceURL: externalResourceUrl,
                            creq: cReq,
                        },
                    },
                    customization: {
                        visual: {
                            hideStatusDetails: false,
                            hideTransactionDate: false,
                            texts: {
                                ctaReturnLabel: "Históricos de Pagamento"
                            }
                        },
                        backUrls: {
                            'return': rota_historico_pagamento.value
                        }
                    },
                    callbacks: {
                        onReady: () => {
                            /*
                                Retorno de chamada chamado quando o Brick estiver pronto.
                                Aqui você pode ocultar carregamentos do seu site, por exemplo.
                            */
                        },
                        onError: (error) => {
                            console.error(error);
                        },
                    },
                };
                window.statusScreenBrickController = await bricksBuilder.create(
                    'statusScreen',
                    'statusScreenBrick_container',
                    settings,
                );
            };
        }
    });

    console.log("✅ Finalização da construção do formulário de pagamento");
}

window.iniciarCheckoutBricks = iniciarCheckoutBricks;

async function getPreferenceId(csrfToken, planoId, valorPlano) {
    try {
        const response = await fetch("/gerar_preference", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'X-CSRF-TOKEN': csrfToken,
            },
            body: JSON.stringify({
                id: planoId,
                valor: valorPlano
            })
        });

        const data = await response.json();

        console.log("Preference ID:", data.preferenceId);

        return data.preferenceId;
    } catch (error) {
        console.error("Erro ao obter preferenceId: ", error);
    }
}
